export default {
  en: {
    dial: {
      fraction: '{n} of {total} ({percentage}%)',
      noValue: '{label}: no data',
    },
    externalLink: {
      altText: 'External link opens in new tab',
    },
    qrCode: {
      altText: 'QR code for your authenticator app',
    },
    helpIcon: {
      altText: 'Help button',
    },
    feedbackButtons: {
      positive: 'Give positive feedback',
      negative: 'Give negative feedback',
      comment: 'Tell us why',
    },
    calendar: {
      previousMonth: 'Previous month',
      nextMonth: 'Next month',
      chooseMonth: 'Choose month',
      previousYear: 'Previous year',
      nextYear: 'Next year',
      chooseYear: 'Choose year',
      previousYears: 'Previous years',
      nextYears: 'Next years',
    },
    pagination: {
      pagination: 'Pagination',
      firstPage: 'First page',
      previousPage: 'Previous page',
      nextPage: 'Next page',
      lastPage: 'Last page',
      pageN: 'Page {n}',
    },
    spinner: {
      altText: 'Loading',
    },
    spinSucceedFail: {
      saving: 'Saving',
      fail: 'Failed to save',
      success: 'Saved',
    },
    files: {
      loader: {
        text: 'Drag & drop your files here or',
        button: 'Select file',
        error: 'Failed to load file',
      },
      downloadError: 'Error downloading attachment',
      filesAttached: '{n} file attached | {n} files attached',
    },
    debug: {
      userRole: 'Change your user role',
      accountType: 'Change your account type',
      comingSoon: {
        title: 'Coming soon',
        subtitle: 'Nothing to see here just yet...',
      },
      zeusWillAlert: 'Zeus users will alert!',
      getError: 'Get error',
      goToZeus: 'Zeus',
      goToNetworkGraph: 'Network graph',
      goToSalesFederatedGraph: 'Federated graph (fake data)',
      orgID: 'Org ID:',
      userID: 'User ID:',
      changeRole: 'Change role:',
      setProfileAsIncomplete: 'Set profile as incomplete',
      copyToClipboard: 'Copy to clipboard',
      copiedToClipboard: 'Copied to clipboard',
      searchFlags: 'Search flags…',
      profileMarkedIncomplete: 'Profile marked as incomplete',
      tabs: {
        featureFlags: 'Feature flags',
        account: 'Account',
        zeus: 'Zeus',
        actions: 'Actions',
        mocks: 'Mocks',
      },
      mocks: {
        enable: 'Enable API mocks',
        enableHelp:
          'Intercept API requests with MSW. Only active scenarios below are mocked; everything else passes through to the real backend.',
        bundleLabel: 'Load a bundle',
        bundlePlaceholder: 'Select a bundle…',
        bundleEmpty: 'No bundles defined yet.',
        postDelayLabel: 'POST delay (ms)',
        postDelayHelp: 'Artificial latency applied to mocked POST/PUT/DELETE responses.',
        scenariosHeading: 'Scenarios',
        scenariosEmpty: 'No scenarios registered.',
        reset: 'Reset to defaults',
        bannerTitle: 'API mocks enabled',
        bannerActive: '{n} scenario group active | {n} scenario groups active',
        bannerNone: 'No scenario groups active',
        bannerDisable: 'Disable',
        bannerDismiss: 'Dismiss',
      },
      failingRequest: 'Make a failing request:',
      failingRequestNote: '(500 for zeus user, 403 for rest)',
      toastMe: 'Toast me:',
      toastSuccess: 'Test success toast!',
      toastError: 'Test error toast!',
      toastInfo: 'Test info toast!',
      toastWarning: 'Test warning toast!',
      success: 'Success',
      error: 'Error',
      info: 'Info',
      warning: 'Warning',
    },
    nav: {
      envWarningHidden: 'Environment warning banner hidden for 10 minutes',
      dev: 'Dev',
      demo: 'Demo',
      gettingStarted: 'Getting started',
      trialEndsIn: 'Your trial ends in {days}',
      trialEndsToday: 'Your trial ends {today}',
      trialEndsInDayCount: '1 day | {n} days',
      trialEndsTodayCount: 'today',
      risks: 'Risks',
      myAssurance: 'My assurance',
      mySecurity: 'My security',
      dashboard: 'Dashboard',
      insights: 'Insights',
      beta: 'Beta',
      new: 'New',
      reporting: 'Reporting',
      communities: 'Community',
      visualisation: 'Visualisation',
      network: 'Network',
      map: 'Map',
      actionCentre: 'Action Centre',
      discussions: 'Discussions',
      suppliers: 'Suppliers',
      policies: 'Policies',
      clients: 'Clients',
      assessment: 'Assessment',
      monitoring: 'Monitoring',
      emergingThreats: 'Emerging Threats',
      settings: 'Settings',
      sharing: 'Trust Centre',
      whatIsRL: 'What is Risk Ledger?',
      debugMenu: 'Debug menu',
      popover: {
        helpGuides: 'Help guides',
        contactUs: 'Contact us',
        chatWithUs: 'Chat with us',
        emailUs: 'Email us at support\\@riskledger.com',
        knowledgeBase: 'Knowledge base',
        assessmentFramework: 'Assessment Framework',
        helpCentre: 'Help Centre',
        settingsSection: 'Settings',
        accountSection: 'Account',
        switchOrganisation: 'Switch organisation',
        signOut: 'Sign out',
      },
      addUsers: 'Add users',
      inviteUsers: 'Invite users',
      version: {
        title: 'Risk Ledger v.{version}',
        updated: 'Updated {date}',
      },
      subEntities: 'Sub-entities',
      documents: 'Documents',
      answerSearch: 'Answer search',
    },
    layout: {
      skipToContent: 'Skip to content',
      skipSecondaryNav: 'Skip secondary navigation',
      loadingOrganisation: 'Loading organisation',
      pageLoaded: '{title} has loaded',
    },
    infiniteLoader: {
      loadMore: 'Load more',
    },
    confirmModal: {
      title: 'Are you sure?',
      closeButtonText: 'Cancel',
      actionButtonText: 'Confirm',
      checkboxText: 'I understand the consequences of this action.',
      checkboxRequired: 'Select the checkbox to confirm',
    },
    ff: {
      featureFlags: 'Feature flags',
      localStorage: 'The default value has changed, it has been persisted to local storage.',
      reset: 'Reset flags to default',
    },
    orderedLabelEditor: {
      addNew: 'Add level',
      addNewPlaceholder: 'Enter label name...',
      addNewSave: 'Save',
    },
    public: {
      privacyPolicy: 'Privacy Policy',
      termsAndConditions: 'Terms & Conditions',
      copyright: '© Copyright Risk Ledger Ltd {year}',
      rlAddress: 'Adam House, 7-10 Adam St, London, WC2N 6AA, United Kingdom',
    },
    richTextArea: {
      toggleBold: 'Toggle bold',
      toggleItalic: 'Toggle italic',
      toggleUnderline: 'Toggle underline',
      toggleList: 'Toggle list',
      toggleLink: 'Toggle link',
      attachFiles: 'Attach files',
      linkPopover: {
        setTitle: 'Set link',
        updateTitle: 'Update link',
        remove: 'Remove',
        save: 'Save',
      },
    },
    dataTable: {
      empty: 'No rows to display',
      showingRange: 'Showing {start}–{end} of {total}',
      error: 'Failed to get rows',
      status: {
        justNow: 'just now',
      },
      searchPlaceholder: 'Search...',
      columns: 'Columns',
      selected: 'Selected {n} row | Selected {n} rows',
      selectAll: 'Select all rows',
      selectRow: 'Select row {name}',
    },
    video: {
      loomCloseButton: 'Close',
      titles: {
        TRIAL_STEP_2: 'Video: connect with Risk Ledger Managed suppliers',
        TRIAL_STEP_3: "Video: understand your suppliers' risk posture",
        EMERGING_THREATS: 'Video: emerging threats walkthrough',
      },
    },
    layouts: {
      applicationLoadError: {
        message: 'The application has failed to load.',
        stepsToFollowHeader: 'To resolve this, try the following steps:',
        tryRefreshing: 'Try refreshing your browser',
        openSiteInPrivacyMode: 'Try opening this site in incognito/privacy mode',
        ensureWhitelistedDomains: 'Ensure riskledger domains are whitelisted by your IT team',
        contactUsThroughIntercom:
          'If none of the above work, contact our support staff by clicking here.',
        intercomMessage: "I'm experiencing an issue with the application loading.",
      },
    },
    cancelWarningModal: {
      title: 'Are you sure you want to leave?',
      body: "Any changes you've made will be lost.",
      no: 'Keep editing',
      yes: 'Yes, leave',
    },
    copyLink: {
      copyTooltip: 'Copy the link to your clipboard.',
      copySuccess: 'Successfully copied link',
    },
    baseInputSelect: {
      noOptions: 'No other options',
    },
    baseFormErrorSummary: {
      title: '{n} field needs fixing | {n} fields need fixing',
    },
    baseInputBlock: {
      optional: '(optional)',
    },
    baseListbox: {
      searchPlaceholder: 'Search',
    },
    baseInputPhone: {
      countryCode: 'Country code',
    },
    baseInputTextArea: {
      charactersLeft: '{n} character left | {n} characters left',
    },
    baseGenericError: {
      retry: 'Retry',
    },
    baseEmptyValue: {
      none: 'None',
    },
    visualisation: {
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      zoomToFit: 'Zoom to fit',
      enterFullscreen: 'Enter fullscreen',
      exitFullscreen: 'Exit fullscreen',
    },
    baseInputEmail: {
      genericEmailWarning:
        '{type} to generic emails are less likely to be accepted. Consider using a direct contact if available.',
      personalEmailWarning:
        'This looks like a personal email address. We recommend using a work email address instead.',
      type: {
        connectionRequest: 'Connection requests',
        invite: 'Invites',
        contactSuggestion: 'Contact suggestions',
        default: 'Emails',
      },
    },
  },
};
